const o = {
  id: "OhioPick4",
  logo: !0,
  name: "Pick 4",
  style: {
    colorPrimary: "#679e35"
  }
};
export {
  o as default
};
